<script lang="ts">
  import Link from "svelte-link";
  import { Col, Row } from "sveltestrap";
  import data from "../../../../Data/Chat/Chat.json";
</script>
<div class="user-content text-center">
    <h5 class="text-uppercase">mark jenco</h5>
    <div class="social-media">
      <ul class="list-inline">
        {#each data.socialdata as chatItem}
          <li class="list-inline-item">
            <Link href={chatItem.link} target="_blank">
              <i class="fa fa-{chatItem.icon}" />
            </Link>
          </li>
        {/each}
      </ul>
    </div>
    <hr />
    <div class="follow text-center">
      <Row>
        {#each data.textdata as chatItem}
          <Col class={chatItem.class}>
            <span>{chatItem.title}</span>
            <div class="follow-num">{chatItem.number}</div>
          </Col>
        {/each}
      </Row>
    </div>
    <hr />
    <div class="text-center">
      <p class="mb-0">Mark.jecno23@gmail.com</p>
      <p class="mb-0">+91 365 - 658 - 1236</p>
      <p class="mb-0">Fax: 123-4560</p>
    </div>
</div>